import cx from 'classnames'
import type { ChangeEvent, LegacyRef, TextareaHTMLAttributes } from 'react'
import { useCallback } from 'react'

import styles from './styles.module.scss'


interface IProps extends TextareaHTMLAttributes<HTMLTextAreaElement>{
  value: string,
  inputRef?: LegacyRef<HTMLTextAreaElement> | undefined,
  error?: boolean,
  onChange: (value: unknown) => void,
  maxLimit?: number,
}

Input.defaultProps = {
  inputRef: undefined,
  error: false,
  maxLimit: undefined,
}

function Input({ value, onChange, inputRef, error, maxLimit, ...props }: IProps): JSX.Element {
  const handleChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value
    if(maxLimit) {
      if(text.length <= maxLimit) {
        onChange(text)
      } else {
        onChange(text.slice(0, maxLimit))
      }
      return
    }
    return onChange(text)
  }, [onChange])

  return (
    <>
      <textarea
        {...props}
        value={value ?? ''}
        onChange={handleChange}
        className={cx(styles.textarea, error && styles.error, props.className)}
        ref={inputRef}
      />
      {maxLimit && (
        <p className={styles.letterLimit} data-test="textarea-limit">
          {value?.length || 0} / {maxLimit}
        </p>
      )}
    </>
  )
}

Input.defaultProps = {
  rules: {},
}

export default Input
